// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useAllocations: () => UseQueryResult<InterfaceContract<Allocation>[], string> = () => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryAllocations'],
    queryFn: async (_, options) => {
      return ledgerApi.queryAllocations(options);
    },
  });
};

export default useAllocations;
